module.exports = __webpack_public_path__ + "img/online-logo.57658326.png";